import React from "react";
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AssessmentIcon from '@material-ui/icons/Assessment';
import FaceIcon from '@material-ui/icons/Face';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import HistoryIcon from '@material-ui/icons/History';
import Avatar from '@material-ui/core/Avatar';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import Report from './routes/report'
import Session from './routes/session'
import Coach from './routes/coach'
import Profile from './routes/profile'
import Players from '../players'
import IntlMessages from "../../../util/IntlMessages";
import { tsToMonthYear } from '../../../util/dateUtil'
import LoadingAlert from "../../../components/LoadingAlert"
import maleAvatar from '../../../assets/images/icons/male-avatar.svg'
import femaleAvatar from '../../../assets/images/icons/female-avatar.svg'

class User extends React.Component {
    constructor() {
        super()
        this.state = {
            value: 0,
        };
    }

    componentDidMount() {
        this.topMenuRoute(0)
        if (this.props.playerInView === null) {
            this.props.history.push('/app/players')
        }
    }
    componentDidUpdate(prevProps) {
        if ((prevProps.assignCoachToPlayerLoader === true && this.props.assignCoachToPlayerLoader === false) || (prevProps.changeCoachToPlayerLoader === true && this.props.changeCoachToPlayerLoader === false) || (prevProps.removeCoachToPlayerLoader === true && this.props.removeCoachToPlayerLoader === false) || (prevProps.playersStoreData !== this.props.playersStoreData)) {
            this.showAlert(prevProps)
        }
    }

    handleChange = (event, value) => {
        this.setState({ value });
        this.topMenuRoute(value)
    };
    topMenuRoute(value) {
        switch (value) {
            case 0:
                this.props.history.push('/app/user/report')
                break
            case 1:
                this.props.history.push('/app/user/session')
                break
            case 2:
                this.props.history.push('/app/user/coach')
                break
            case 3:
                this.props.history.push('/app/user/profile')
                break
            default:
                this.props.history.push('/app/user/report')
                break
        }
    }
    showAlert(prevProps) {
        if (prevProps.assignCoachToPlayerLoader === true && this.props.assignCoachToPlayerLoader === false) {
            this.props.assignCoachToPlayerError === null ? NotificationManager.success(<IntlMessages id="notification.assignCoach.successMessage" />) : NotificationManager.error(<IntlMessages id="notification.assignCoach.errorMessage" />);
        } else if (prevProps.changeCoachToPlayerLoader === true && this.props.changeCoachToPlayerLoader === false) {
            this.props.changeCoachToPlayerError === null ? NotificationManager.success(<IntlMessages id="notification.changeCoach.successMessage" />) : NotificationManager.error(<IntlMessages id="notification.changeCoach.errorMessage" />);
        } else if (prevProps.removeCoachToPlayerLoader === true && this.props.removeCoachToPlayerLoader === false) {
            this.props.removeCoachToPlayerError === null ? NotificationManager.success(<IntlMessages id="notification.removeCoach.successMessage" />) : NotificationManager.error(<IntlMessages id="notification.removeCoach.errorMessage" />);
        }
    }

    render() {
        const { match } = this.props;
        const { value } = this.state;
        const playerName = this.props.playerInView != null ? this.props.playerInView.fullName : "";
        const activeSince = this.props.playerInView != null ? tsToMonthYear(this.props.playerInView.createdAtTs) : "";
        const message = this.props.assignCoachToPlayerLoader ? "Assigning coach" : this.props.changeCoachToPlayerLoader ? "Changing coach" : this.props.removeCoachToPlayerLoader ? "Removing coach" : ""
        const avatarIcon = this.props.playerInView != null ? (this.props.playerInView.hasOwnProperty("playerInfo") ? (this.props.playerInView.playerInfo.hasOwnProperty("gender") ? (this.props.playerInView.playerInfo.gender === "female" ? femaleAvatar : maleAvatar) : maleAvatar) : maleAvatar) : maleAvatar
        return (
            <div className="player-inside">
                <LoadingAlert
                    message={message}
                />
                <div className="player-menu">
                    <div className='row'>
                        <div className='col-md-3 col-sm-12 col-xs-12'>
                            <div className="media align-items-center flex-nowrap" style={{ height: "70px" }}>
                                <div className="mx-3">
                                    <Avatar
                                        alt={""}
                                        src={avatarIcon}
                                        className="user-avatar-lg"
                                    />
                                </div>
                                <div className="media-body pt-2 pr-3">
                                    <div className="d-flex align-items-center">
                                        <h4 className="mr-1 mb-0">{playerName}</h4>
                                    </div>
                                    <p className="mb-0 text-grey jr-fs-sm d-none d-xl-block">Active since: {activeSince}</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-9 col-sm-12 col-xs-12'>
                            <AppBar position="static" color="default">
                                <Tabs style={{ height: "70px" }}
                                    value={value}
                                    onChange={this.handleChange}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    scrollButtons="auto"
                                    variant="standard"
                                    centered={true}
                                >
                                    <Tab icon={<AssessmentIcon />} label="Report" />
                                    <Tab icon={<HistoryIcon />} label="Session" />
                                    <Tab icon={<SupervisorAccountIcon />} label="Coach" />
                                    <Tab icon={<FaceIcon />} label="Profile" />
                                </Tabs>
                            </AppBar>
                        </div>
                    </div>
                </div>
                <div className="player-content">
                    <Switch>
                        <Route path={`${match.url}/report`} component={Report} />
                        <Route path={`${match.url}/session`} component={Session} />
                        <Route path={`${match.url}/coach`} component={Coach} />
                        <Route path={`${match.url}/profile`} component={Profile} />
                        <Route path={`app/players`} component={Players} />
                    </Switch>
                </div>
            </div >
        );
    }

}

const mapStateToProps = ({ player }) => {
    const { playerInView, assignCoachToPlayerLoader, changeCoachToPlayerLoader, removeCoachToPlayerLoader, assignCoachToPlayerError, changeCoachToPlayerError, removeCoachToPlayerError } = player;
    return { playerInView, assignCoachToPlayerLoader, changeCoachToPlayerLoader, removeCoachToPlayerLoader, assignCoachToPlayerError, changeCoachToPlayerError, removeCoachToPlayerError }
};
export default withRouter(connect(mapStateToProps)(User));